<template>
<!-- ユーザ詳細画面 -->
<CCard>
  <CCardHeader>
    <h2>ユーザ詳細</h2>
  </CCardHeader>
   <CCardBody>
     <CRow>
      <CCol sm="6">
        <table class="table" v-if="items">
          <tr>
            <th>社員番号</th>
            <td>{{ items.employee_id }}</td>
          </tr>
          <tr>
            <th>氏名</th>
            <td>{{ items.name }}</td>
          </tr>
          <tr>
            <th>所属部署</th>
            <td>{{ items.department_name || '' }}</td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>{{ items.telephone }}</td>
          </tr>
          <tr>
            <th>住所</th>
            <td>{{ items.address }}</td>
          </tr>          
          <tr>
            <th>E-Mail</th>
            <td>{{ items.email }}</td>
          </tr>
          <tr>
            <th>入社年月日</th>
              <td v-if="items.hire_date !== 'null'">{{ formatDate(items.hire_date) }}</td>
              <td v-else></td>
          </tr>
          <tr>
            <th>ユーザ種別</th>
            <td>{{ items.authority_name }}</td>
          </tr>
          <tr>
            <th>承認者権限</th>
            <td v-if="items.approver_flg === true">有</td>
            <td v-else>無</td>
          </tr>
          <tr>
            <th>週稼働日数（有休付与区分）</th>
            <td>
              {{
                items.working_days === 5
                  ? '通常(週5日)'
                  : (items.working_days === 0 ? '有休付与無し' : ('週' + items.working_days + '日'))
              }}
            </td>
          </tr>
          <tr>
            <th>有給日数</th>
            <td>{{ items.paid_days }}<block v-if="items.paid_days">日</block><block v-else></block></td>
          </tr>
          <tr>
            <th>代休日数</th>
            <td>{{ items.comp_days }}<block v-if="items.comp_days">日</block><block v-else></block></td>
          </tr>
          <tr>
            <th>今期有休消化日数</th>
            <td>{{ items.paid_days_used }}<block v-if="items.paid_days_used">日</block><block v-else></block></td>
          </tr>
          <tr>
            <th>有給付与月</th>
            <td>{{ items.paid_days_add }}<block v-if="items.paid_days_add">月</block><block v-else></block></td>
          </tr>
          <tr>
            <th>固定内残業</th>
            <td>{{ items.fixed_over_time }}<block v-if="items.fixed_over_time"></block><block v-else></block></td>
          </tr>
          <tr>
            <th>Slack ID</th>
            <td>{{ items.slack_id }}</td>
          </tr>
        </table>
      </CCol>
    </CRow>
    <CRow class="mt-3 align-items-center">
    <!-- 戻るボタン：左寄せ -->
    <CCol class="text-start">
      <router-link :to="{ name: list }">
        <button class="btn btn-secondary" @click="valueCheck">戻る</button>
      </router-link>
    </CCol>
    <!-- 編集ボタン：中央寄せ -->
    <CCol class="text-center">
      <router-link :to="{ name: updateTop, params: { value: items } }">
        <button class="btn btn-info">編集</button>
      </router-link>
    </CCol>
    <!-- 空白スペース用 -->
    <CCol ></CCol>
  </CRow>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './ConstList'
import axios from 'axios'
export default {
  name: 'Info',
  data() {
    return {
      authority: [],
      items: null,
      item: '',
      id: '',
      list: '',
      updateTop: ''
    } 
  },

created() {
        this.list = ConstList.ROUTE_LIST;
        this.updateTop = ConstList.UPDATE_TOP;
      },

  // 一覧から選択したユーザの情報取得
  mounted: function () {
      this.id = this.$route.params.id
      const id = parseInt(this.id);
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/users/' + id)
        .then(response => {
          this.items = response.data
          if (this.items.length === 0) {
            this.errors.push(ConstList.EMPTY)
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
  methods: {
    // ユーザ管理へ遷移する際の入力値チェック
    valueCheck: function () {
      this.$router.push({ 
        name: this.list
      });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
}
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
